import { useEffect, useMemo } from 'react';
import { useLocation } from 'react-router';

import { useTrackPageViewMutation } from '../_graphql/mutation/TrackPageView.hook';

type Props = {
	skip?: boolean;
};

export const useTrackPageView = ({ skip }: Props) => {
	const [trackPageView] = useTrackPageViewMutation();
	const { pathname, search } = useLocation();

	const pagePath = useMemo(() => pathname + search, [pathname, search]);

	useEffect(() => {
		if (skip) return;

		trackPageView({
			variables: {
				trackPageViewInput: {
					pagePath
				}
			}
		});
	}, [trackPageView, pagePath, skip]);
};
